module.exports = __webpack_public_path__ + "img/id1.20913304.png";